// extracted by mini-css-extract-plugin
module.exports = {"tags":"_2FhYdxRwo1GDEue4ZM29o2","tag":"_3iYMt1B5wypkd3WSLXOdB1"};